
import { Row, Rows } from "../../../interfaces";
import { withCellStyles, getCell, formats } from "../../../utils";
import { headerToColumnLetter } from "../../../utils/functions";

import { BmTemplateInternals, BudgetModalTemplateCurrentState } from "../budget-helper-internal";
import { boldAndBackgroundGray, textBold } from "../../../excelStyles";
import { BudgetModelFormGroup } from "../../../../models/budget-model/pojo/bm-form";
import { SwitcherDashBracesPipe } from "../../../../../util/pipes/switcherDashBraces.pipe";
import { BmItemValue } from "../../../../models/budget-model/pojo/bm-classes-values";

export class InvestmentSection {
  constructor(
    private readonly budgetForm: BudgetModelFormGroup,
    private readonly helper: BmTemplateInternals,
  ) { }

  fillInvestmentRows(rows: Rows, current: BudgetModalTemplateCurrentState): void {
    this.prepareInvestmentRow(rows, current);
    this.prepareInvestmentRowPcnt(rows, current);
  }

  private prepareInvestmentRow(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const investmentTotalRow: Row = [];
    const pipe = new SwitcherDashBracesPipe();
    const investmentStandardValue = current.investmentStandardValue;
    const updatedCommitment = pipe.transform(investmentStandardValue, 1, 0, false, '', '');
    investmentTotalRow.push(withCellStyles(`Investment (Total ${updatedCommitment})`, textBold));
    const investmentTotalItems = this.budgetForm.controls.modelData.controls.investment.controls.itemsValue.getRawValue() as BmItemValue[];
    const investmentDataUpdated = this.helper.setNullToDataAfterYearForBmItems(investmentTotalItems, true);
    investmentDataUpdated.forEach((item, index) => {
      if (index === 0) {
        return;
      }
      if (item) {
        item.itemValue = item.itemValue ?? investmentStandardValue;
      }
      this.helper.pushSumOrValueWIthOutZeroIndex(investmentTotalRow, index, item, current.rowIndex, true);
    });

    this.helper.pushYearsTotalCellBold(investmentTotalRow, current.rowIndex, current.yearsIndexArray);
    this.helper.prepareCellForTotalPcnt(investmentTotalRow, current, true);
    newData.push(investmentTotalRow);
    this.helper.setCellForTotalPcntOfCommitment(investmentTotalRow, current.rowIndex, current.indexOfTotalColumn, true);
    current.totalCapitalReqIndex.push(current.rowIndex);
  }

  private prepareInvestmentRowPcnt(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const investmentPcntTotalRow: Row = [];
    investmentPcntTotalRow.push(withCellStyles('Investment, % ( out of 100%)', textBold));

    current.expandedHeadersWithYear.forEach((header) => {
      // null header marks an empty narrow column,
      // header can not be undefined
      if (header === null) {
        investmentPcntTotalRow.push(null);
      } else if (header !== 'Budget') {
        investmentPcntTotalRow.push(withCellStyles(getCell({
          f: `IFERROR(${headerToColumnLetter(header, current.expandedHeadersWithYear)}${current.rowIndex}/${current.investmentStandardValue},0)`,
          z: formats.percents, t: 'n',
        }), header.includes('Y') ? boldAndBackgroundGray : textBold));
      }
    });
    current.rowIndex++;

    this.helper.setEmptyTotalsRowWithStyle(investmentPcntTotalRow);
    newData.push(investmentPcntTotalRow);
    current.rowIndex++;
  }
}
